import { type Theme } from '@store/settings/types';

import {
  DARK_CLASS,
  DARK_HIGH_CONTRAST_CLASS,
  HIGH_CONTRAST_CLASS,
} from './themeClass';

const THEME_CLASS: Record<Theme, string | undefined> = {
  dark: DARK_CLASS,
  highContrast: HIGH_CONTRAST_CLASS,
  darkHighContrast: DARK_HIGH_CONTRAST_CLASS,
  light: undefined,
  system: undefined,
};

const setTheme = (theme: Theme) => {
  document.documentElement.classList.remove(
    DARK_CLASS,
    HIGH_CONTRAST_CLASS,
    DARK_HIGH_CONTRAST_CLASS,
  );

  const themeClass = THEME_CLASS[theme];

  if (themeClass !== undefined) {
    document.documentElement.classList.add(themeClass);
  }
};

export { setTheme };
